import { render } from "./MdIcon.vue?vue&type=template&id=71e3fa94&scoped=true&ts=true"
import script from "./MdIcon.vue?vue&type=script&lang=ts"
export * from "./MdIcon.vue?vue&type=script&lang=ts"

import "./MdIcon.vue?vue&type=style&index=0&id=71e3fa94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e3fa94"]])

export default __exports__